/*----------------------------------
- ROUTE: /resources/domaining-news
----------------------------------*/

/**
 * @docs docs/features/domain-news
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { definePageRoute } from '@common/router/definitions';

import {
    buildDomainingNewsArchiveRouteData,
    renderDomainingNewsArchiveRoute,
} from './lib/route';

import './pagination';
import './date';

/*----------------------------------
- PAGE
----------------------------------*/

export default definePageRoute({
    path: '/resources/domaining-news',
    options: { auth: false, layout: false },
    data: buildDomainingNewsArchiveRouteData,
    render: renderDomainingNewsArchiveRoute,
});
